import { DosumentsSection } from "./components/documentsSection";

export const ClientDocuments = ({
  isDocumentsLoading,
  isDownloadLoading,
  docs = [],
  handleDownload,
}) => {

  return (
    <div className="flex flex-col gap-4 min-h-[70vh] max-lg:mb-[110px]">
      <div className='w-full'>
        <DosumentsSection 
          title={"Τύπος εγγράφου"} 
          documentsList={docs}
          isDocumentsLoading={isDocumentsLoading}
          section={"client"}
        />
      </div>
    </div>
  );
};